<template>
  <div>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/company' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>单位管理</el-breadcrumb-item>
      <el-breadcrumb-item>单位列表</el-breadcrumb-item>
    </el-breadcrumb>    
    <el-card>
      <!-- 添加单位 -->
      <el-row :gutter="20">
        <el-col :span="6">
          <el-input
            size="small"
            clearable
            placeholder="请输入搜索内容"
            v-model="queryInfo.query"
            @clear="getList">
            <el-button
              slot="append"
              @click="getList"
              icon="el-icon-search">
            </el-button>
          </el-input>
        </el-col>
        <el-col :span="6">
          <el-button 
            type="primary" 
            size="small" 
            @click="showAddDialog">
            添加单位
          </el-button>
        </el-col>
      </el-row> 
      <!-- 表格 -->
      <el-row>
        <el-table :data="tableData" border stripe>
          <el-table-column 
            type="index" 
            align="center" 
            size="mini" 
            width="50">
          </el-table-column>
          <el-table-column
            align="center"
            v-for="(item, index) in userCloumn"
            :key="index"
            size="mini"
            :prop="item.name"
            :min-width="item.minWidth"
            :label="item.label">
          </el-table-column>
          <el-table-column
            align="center"
            label="操作"
            width="220px"
            fixed="right">
            <template slot-scope="scope">
              <el-button
                type="primary"
                @click="showEditDialog(scope.row)"
                size="mini">
                编辑
              </el-button>
              <el-button
                type="danger"
                icon="el-icon-delete"
                @click="removeUser(scope.row.id)"
                size="mini">
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-row>  
      <!-- 页码 -->
      <el-row>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryInfo.pagenum"
          :page-sizes="[2, 5, 10, 15]"
          :page-size="queryInfo.pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>      
      </el-row>   
    </el-card>

    <!-- 添加/编辑 单位 -->
    <el-dialog
      :title="`${userTitle}单位`"
      :visible.sync="userDialog"
      width="38%"
      @close="userDialogClosed">
      <el-form
       :model="userForm"
       :rules="userFormRules"
       ref="userFormRef"
       label-width="140px">
        <el-form-item label="单位名称" style="text-align: left;" prop="name">
          <el-input size="small" v-model="userForm.name"></el-input>
        </el-form-item>
        <el-form-item label="单位地址" prop="address">
          <el-input size="small" v-model="userForm.address"></el-input>
        </el-form-item>
        <el-form-item label="用水人数" prop="people" >
          <el-input size="small" v-model="userForm.people"></el-input>
        </el-form-item>
        <el-form-item label="年计划用水(吨)" prop="plan">
          <el-input size="small" v-model="userForm.plan"></el-input>
        </el-form-item>
        <el-form-item label="用水定额(L/人*日)" prop="p_plan">
          <el-input size="small" v-model="userForm.p_plan"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="userDialog = false" size="small">取消</el-button>
        <el-button v-if="userTitle=='添加'" type="primary" @click="addUserBtn" size="small">确定</el-button>
        <el-button v-else type="primary" @click="editUser" size="small">确定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import table from '@/mixins/tables'
export default {
  data () {
    const generateData = manageArr => {
      const manageData = [];
      var pinyin = [""];
      manageArr.forEach((manage, index) => {
        manageData.push({
          label: manage.name,
          key: manage.id,
          pinyin: pinyin[0]
        });
      });
      return manageData;
    };

    var checkMobile = (rule, val , cb) => {
      const regMobile = /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/
        if (regMobile.test(val)) {
          return cb()
        } else {
          cb(new Error('请输入合法手机号'))
        }
    }
    return {
      userTitle:'添加',
      userDialog: false,
      xfDialog: false,
      manageDialog: false,
      editID: 0,
      manageData: [],
      selectManageVal: [],
      userForm: {
        companyid:0,
        name: '',
        address: '',
        people: '',
        plan:"",
        p_plan:""
      },
      xfForm: {
        time:""
      },
      linkList: [],
      timeList:[
        {value:0,label:"30天"},
        {value:1,label:"90天"},
        {value:2,label:"180天"},
        {value:3,label:"365天"},
      ],
      xfFormRules:{
        time:[
          { required: true, message: '请选择续费期限', trigger: 'blur' },
        ]
      },
      userFormRules: {
        name: [
          {
            required: true,
            message: '请输入单位名称',
            trigger: 'blur'
          },
          {
            min: 2,
            max: 128,
            message: '单位名长度在 2 到 128 个字符之间',
            trigger: 'blur'
          }
        ],
        address: [
          {
            required: true,
            message: '请输入单位地址',
            trigger: 'blur'
          },
          {
            min: 2,
            max: 128,
            message: '单位名长度在 2 到 128 个字符之间',
            trigger: 'blur'
          }
        ],
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { validator: checkMobile, trigger: 'blur' }
        ],
        people:[
          { required: true, message: '请录入用水人数', trigger: 'blur' },
        ],
        plan:[
          { required: true, message: '请录入年计划用水', trigger: 'blur' },
        ],
        p_plan:[
          { required: true, message: '请录入用水定额', trigger: 'blur' },
        ]
      },  
      tableData: [ ],
      userCloumn: [
        { name: 'name', label: '单位名称', minWidth: '160px' },
        { name: 'address', label: '单位地址', minWidth: '160px' },
        { name: 'people', label: '用水人数', minWidth: '160px' },
        { name: 'plan', label: '年计划用水（吨）', minWidth: '160px' },
        { name: 'p_plan', label: '用水定额（L/人*日）', minWidth: '160px' }     
      ],  
    }
  },
  mixins: [table],
  created () {
    this.getList()
  },
  methods: {
    getList() {
      var that = this;
      this.$post('/apis/manage/company/companyList',{
              page:that.queryInfo.pagenum-1,
              length:that.queryInfo.pagesize,
              token:sessionStorage.getItem('token'),
              name:that.queryInfo.query
          }).then(function(res){
            if(res.errno == 0){
              var data = res.data;
              var newList = [];
              for(var i=0;i<data.list.length;i++){
                newList.push({
                  id:data.list[i].id,
                  value:data.list[i].id,
                  name:data.list[i].name,
                  address:data.list[i].address,
                  people:data.list[i].people,
                  plan:data.list[i].plan,
                  p_plan:data.list[i].p_plan
                })
              }
              that.tableData = newList;
              that.total = data.totalCount;
            }else if(res.errno == 99){
              that.$message.info(res.errmsg);
              sessionStorage.clear();
              that.$router.push("/login");
          }else{
            that.$message.info(res.errmsg);
          }
          }).catch(function(err){
            window.console.log(err);
          });
      
    },

    showAddDialog() {
      this.userDialog = true
      this.userTitle = '添加'
    },
    userDialogClosed() {
      this.$refs.userFormRef.resetFields()
      this.userForm.name = ""
      this.userForm.address = ""
      this.userForm.people = ""
      this.userForm.plan = ""
      this.userForm.p_plan = ""
      this.userForm.companyid = ""
    },
    xfDialogClosed() {
      this.$refs.xfFormRef.resetFields()
      this.xfForm.time = ""
      this.userForm.companyid = ""
    },
    addUserBtn() {
      this.$refs.userFormRef.validate( valid => {
        if (valid) {
          var that = this;
          this.$post('/apis/manage/company/addCompany',{
              name:this.userForm.name,
              address:this.userForm.address,
              people:this.userForm.people,
              plan:this.userForm.plan,
              p_plan:this.userForm.p_plan,
              token:sessionStorage.getItem('token'),
          }).then(function(res){
            if(res.errno == 0){
              that.$message.success('新增单位成功');
              that.userDialog = false;
              that.getList();
            }else{
              that.$message.info(res.errmsg);
            }
          }).catch(function(err){
            window.console.log(err);
          });
        }
      }) 
    },
    showEditDialog(row) {
      console.log('显示编辑单位');
      this.userDialog = true
      this.userTitle = '编辑'
      this.userForm.name = row.name
      this.userForm.address = row.address
      this.userForm.people = row.people
      this.userForm.companyid = row.id
      this.userForm.plan = row.plan
      this.userForm.p_plan = row.p_plan
    },
    editUser() {
      this.$refs.userFormRef.validate( valid => {
        if (valid) {
          var that = this;
          this.$post('/apis/manage/company/editCompany',{
              companyid:this.userForm.companyid,
              name:this.userForm.name,
              address:this.userForm.address,
              people:this.userForm.people,
              plan:this.userForm.plan,
              p_plan:this.userForm.p_plan,
              token:sessionStorage.getItem('token'),
          }).then(function(res){
            if(res.errno == 0){
              that.$message.success('单位修改成功');
              that.userDialog = false;
              that.getList();
            }else{
              that.$message.info(res.errmsg);
            }
          }).catch(function(err){
            window.console.log(err);
          });
        }
      }) 
    },
    removeUser(id) {
      var that = this;
      const confirmResult = this.$confirm(
        '此操作将永久删除该单位，并且删除单位相关的人员、区域、水表信息，是否继续？',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'          
        }
      ).then(async () => { //  不要忘记加 async
              window.console.log(1);
              that.$post('/apis/manage/company/delCompany',{
                companyid:id,
                token:sessionStorage.getItem('token'),
              }).then(function(res){
                if(res.errno == 0){
                  console.log('删除单位');
                  that.$message.success('单位删除成功');
                  that.getList();
                }else{
                  that.$message.info(res.errmsg);
                }
              }).catch(function(err){
                
                window.console.log(2);
              });
            
        }).catch(err => err)
    },
    // 右侧列表元素变化时触发
    newManage(e) {
      console.log(e);
    },
  }
}
</script>

<style>

</style>